let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([require("./helpers/browser/css-loader")(require('./helpers/bundle-manifest').resolve("9SN7u")), load("6B0JB")]).then(() => parcelRequire('egoXV'));